<template lang="pug">
#f_a_q
  custom-header(
    :title="FAQPage.area01_Title",
    :subTitle="FAQPage.area01_SubTitle",
    :image="FAQPage.area01_Image",
    :buttonName="FAQPage.area01_ButtonName",
    :buttonURL="FAQPage.area01_ButtonURL"
  )
  section.container
    h2.i_h2_title.text-center.i_mt_10 聚焦問題 解答疑惑
    nav.top_tab.d-flex.flex-wrap.flex-md-nowrap.justify-content-start.justify-content-md-center.i_ml_per_sm_1
      nav-tab(
        v-for="(productCategory, index) in productCategory.ProductCategoryList",
        :key="index",
        :title="productCategory.ProductCategoryName",
        :selected="selectedLink == index",
        @click.native="changeTab(index)"
      )
    .sub_tab.d-flex.justify-content-center.i_mt_6
      indicator-tab(
        v-for="(product, index) in productDetail.ProductList",
        :key="index",
        :tabContent="product",
        :selected="selectedSubLink == index",
        @click.native="changeSubTab(index)"
      )

  question-wrapper(:questions="focusQuestionList")

  section.container
    .row.i_mt_17.i_mt_md_14.i_pb_10
      .col-12.col-md-6.i_mt_8(
        v-for="(commonQuestion, index) in commonQuestionList",
        :key="index"
      )
        question-wide(:question="commonQuestion")
  dedicated-line
</template>

<script>
import CustomHeader from "@/components/customer_service/Header";
import { getFAQPage } from "@/json/customer_service";
import { getProductCategory } from "@/json/product";
import { getFAQDetail } from "@/json/FAQ";
import NavTab from "@/components/customer_service/NavTab";
import IndicatorTab from "@/components/common/IndicatorTab";
import QuestionWide from "@/components/common/QuestionWide";
import DedicatedLine from "@/components/customer_service/DedicatedLine";
import QuestionWrapper from "@/components/common/QuestionWrapper";

export default {
  name: "CustomerServiceFAQ",
  metaInfo() {
    return {
      title: this.FAQPage.SEO_Title,
      meta: [{ name: "description", content: this.FAQPage.SEO_Description }],
    };
  },
  components: {
    "custom-header": CustomHeader,
    "nav-tab": NavTab,
    "indicator-tab": IndicatorTab,
    "question-wide": QuestionWide,
    "dedicated-line": DedicatedLine,
    "question-wrapper": QuestionWrapper,
  },
  data() {
    return {
      FAQPage: {},
      productCategory: {},
      productDetail: {},
      FAQDetail: {},
      commonQuestionList: [],
      focusQuestionList: [],
      selectedLink: 0,
      selectedSubLink: 0,
    };
  },
  created() {
    this.getFAQPage();
    this.getProductCategory();
  },
  methods: {
    changeTab(index) {
      this.selectedLink = index;
      this.productDetail = this.productCategory.ProductCategoryList[index];
      this.changeSubTab(0);
    },
    changeSubTab(index) {
      this.selectedSubLink = index;
      this.productQuestionList = [];
      this.commonQuestionList = [];
      this.focusQuestionList = [];
      let tempId = this.productDetail.ProductList[index].ProductID;
      for (let index in this.FAQDetail.FAQDeatilList) {
        let detail = this.FAQDetail.FAQDeatilList[index];
        if (
          this.FAQPage.area02_FocusCategory == detail.FAQCategoryID &&
          detail.FAQvsProductID.includes(tempId)
        ) {
          this.focusQuestionList.push(detail);
        }

        if (
          (detail.FAQID == this.FAQPage.area02_FAQ01ID ||
            detail.FAQID == this.FAQPage.area02_FAQ02ID) &&
          this.commonQuestionList.length < 2
        ) {
          this.commonQuestionList.push(detail);
        }
      }
    },
    getFAQPage() {
      getFAQPage().then((response) => {
        this.FAQPage = response.data;
      });
    },
    getFAQDetail() {
      getFAQDetail().then((response) => {
        this.FAQDetail = response.data;
        if (
          this.productCategory.ProductCategoryList &&
          this.productCategory.ProductCategoryList.length > 0
        ) {
          this.changeTab(0);
        }
      });
    },
    getProductCategory() {
      getProductCategory().then((response) => {
        this.productCategory = response.data;
        this.getFAQDetail();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/faq";
</style>
